// Conversa do contato no WhatsApp (aluno, bot e atendentes), gravada pelo backend em
// conversasWhatsApp/{tenantId}_{telefone}/mensagens. Mostra as mensagens mais recentes.
import React, { useEffect, useRef, useState } from 'react';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { firestore } from '../../config/firebaseConfig';
import { variantesTelefone } from '../relatorios/util';

const QUANTAS = 60;
const AUTORES = { aluno: 'Aluno', ia: 'IA', bot: 'Bot (curso)', atendente: 'Equipe', acao: 'Ação da IA' };

const horario = (em) => {
  const data = em && em.toDate ? em.toDate() : null;
  return data ? data.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
};

function ConversaWhatsApp({ tenantId, contato }) {
  const [mensagens, setMensagens] = useState(null);
  const [erro, setErro] = useState('');
  const fimRef = useRef(null);

  useEffect(() => {
    let ativo = true;
    const telefones = [
      ...(contato.whatsappId ? [String(contato.whatsappId).split('@')[0]] : []),
      ...variantesTelefone(contato.telefone),
    ].filter((t, i, todos) => t && todos.indexOf(t) === i);

    (async () => {
      try {
        for (const telefone of telefones) {
          const snap = await getDocs(query(
            collection(firestore, 'conversasWhatsApp', `${tenantId}_${telefone}`, 'mensagens'),
            orderBy('em', 'desc'),
            limit(QUANTAS),
          ));
          if (!snap.empty) {
            if (ativo) setMensagens(snap.docs.map((d) => ({ id: d.id, ...d.data() })).reverse());
            return;
          }
        }
        if (ativo) setMensagens([]);
      } catch (e) {
        console.error('Conversa do contato:', e);
        if (ativo) setErro('Não foi possível carregar a conversa.');
      }
    })();
    return () => { ativo = false; };
  }, [tenantId, contato.whatsappId, contato.telefone]);

  useEffect(() => {
    if (mensagens && mensagens.length && fimRef.current) fimRef.current.scrollIntoView({ block: 'nearest' });
  }, [mensagens]);

  if (erro) return <p className="ct-suave">{erro}</p>;
  if (!mensagens) return <p className="ct-suave">Carregando a conversa...</p>;
  if (!mensagens.length) {
    return <p className="ct-suave">Nenhuma conversa gravada ainda. As conversas pelo WhatsApp ficam gravadas a partir de 30/10/2026.</p>;
  }

  return (
    <div className="ct-conversa" aria-label={`Últimas ${mensagens.length} mensagens`}>
      {mensagens.map((m) => (
        <div key={m.id} className={`ct-conversa__msg ct-conversa__msg--${m.de === 'aluno' ? 'aluno' : 'empresa'}`}>
          <span className="ct-conversa__autor">{AUTORES[m.de] || m.de} · {horario(m.em)}</span>
          <p>{m.texto}</p>
        </div>
      ))}
      <div ref={fimRef} />
    </div>
  );
}

export default ConversaWhatsApp;
